function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../../locales/keys';
var ServiceFeaturesDialogController = /*#__PURE__*/function () {
  function ServiceFeaturesDialogController($anchorScroll, $location) {
    _classCallCheck(this, ServiceFeaturesDialogController);
    Object.assign(this, {
      $anchorScroll: $anchorScroll,
      $location: $location,
      CustomerCareKeys: CustomerCareKeys,
      errors: [],
      MAXIMUM_PRICING_PLAN: 1,
      MINIMUM_PRICING_PLAN: 0,
      stateOfCollapsible: {},
      countOfSelectedPricingPlans: {},
      onPricingPlanSelection: this.onPricingPlanSelection.bind(this),
      productsOverMax: {},
      selectedServiceFeatures: []
    });
  }
  return _createClass(ServiceFeaturesDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.newconnect = 'newconnect';
      var featuresVisited = [];
      this.selectedServiceFeatures = [];
      this.serviceFeatures.forEach(function (serviceFeature) {
        var index = featuresVisited.indexOf(serviceFeature.pricingPlanId);
        if (index > -1) {
          _this.selectedServiceFeatures[index].quantity++;
        } else {
          serviceFeature.quantity = 1;
          featuresVisited.push(serviceFeature.pricingPlanId);
          _this.selectedServiceFeatures.push(_objectSpread({}, serviceFeature));
        }
      });
      if (this.selectedServiceFeatures.length) {
        this.countOfSelectedPricingPlans = this.countSelectedServiceFeaturePricingPlan();
      }
    }
  }, {
    key: "onCollapse",
    value: function onCollapse(product) {
      var _this2 = this;
      return function (isCollapsed) {
        _this2.stateOfCollapsible[product.id] = !isCollapsed;
        if (!isCollapsed && !product.pricingPlans.length) {
          _this2.onProductPricingPlansRequested()(product.id);
        }
      };
    }
  }, {
    key: "onPricingPlanSelection",
    value: function onPricingPlanSelection(product, productName) {
      var _this3 = this;
      return function (quantity, pricingPlanId, pricingPlanName, shoppingCartItemBillerRuleDetails) {
        var serviceFeatureToModify = _this3.selectedServiceFeatures.find(function (serviceFeature) {
          return serviceFeature.productId === product.id && serviceFeature.pricingPlanId === pricingPlanId;
        });
        if (serviceFeatureToModify) {
          serviceFeatureToModify.quantity = quantity;
          serviceFeatureToModify.billerRuleDetails = shoppingCartItemBillerRuleDetails;
        } else {
          if (product.maximumQuantity === 1) {
            _this3.selectedServiceFeatures = (_this3.selectedServiceFeatures || []).filter(function (service) {
              return service.productId !== product.id;
            });
          }
          _this3.selectedServiceFeatures.push({
            pricingPlanId: pricingPlanId,
            pricingPlanName: pricingPlanName,
            productId: product.id,
            productName: productName,
            quantity: quantity,
            billerRuleDetails: shoppingCartItemBillerRuleDetails
          });
        }
        var productFilteredServiceFeatures = _this3.selectedServiceFeatures.filter(function (serviceFeature) {
          return serviceFeature.quantity !== 0 && product.id === serviceFeature.productId;
        });
        var totalQuantity = productFilteredServiceFeatures.reduce(function (totalQuantity, selectedServiceFeature) {
          return totalQuantity + selectedServiceFeature.quantity;
        }, 0);
        if (productFilteredServiceFeatures.length > product.max || totalQuantity > product.maximumQuantity) {
          _this3.productsOverMax[product.id] = i18n.translate(_this3.CustomerCareKeys.ATTRIBUTES.SERVICE_FEATURES.PRODUCT_OVER_MAXIMUM, {
            productName: product.name
          });
        } else {
          delete _this3.productsOverMax[product.id];
        }
        _this3.countOfSelectedPricingPlans = _this3.countSelectedServiceFeaturePricingPlan();
        _this3.errors = Object.values(_this3.productsOverMax);
      };
    }
  }, {
    key: "getServiceFeatureValue",
    value: function getServiceFeatureValue(productId, pricingPlanId) {
      var selectedServiceFeature = this.selectedServiceFeatures.find(function (serviceFeature) {
        return serviceFeature.productId === productId && serviceFeature.pricingPlanId === pricingPlanId;
      });
      return selectedServiceFeature ? pathOr(1, ['quantity'], selectedServiceFeature) : 0;
    }
  }, {
    key: "getFilteredServiceFeatures",
    value: function getFilteredServiceFeatures() {
      return this.selectedServiceFeatures.filter(function (serviceFeature) {
        return serviceFeature.quantity !== 0;
      });
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      if (!this.errors.length) {
        this.onSelection()(this.getFilteredServiceFeatures());
      } else {
        var old = this.$location.hash();
        this.$location.hash('serviceFeaturesTop');
        this.$anchorScroll();
        this.$location.hash(old);
      }
    }
  }, {
    key: "countSelectedServiceFeaturePricingPlan",
    value: function countSelectedServiceFeaturePricingPlan() {
      return this.selectedServiceFeatures.reduce(function (countPrim, selectedPricingPlan) {
        if (countPrim[selectedPricingPlan.pricingPlanId]) {
          countPrim[selectedPricingPlan.pricingPlanId] += countPrim[selectedPricingPlan.pricingPlanId];
        } else {
          if (selectedPricingPlan.quantity === 0) {
            countPrim[selectedPricingPlan.pricingPlanId] = 0;
          } else {
            countPrim[selectedPricingPlan.pricingPlanId] = selectedPricingPlan.quantity || 1;
          }
        }
        return countPrim;
      }, {});
    }
  }]);
}();
export default {
  template: require('./service.features.dialog.html'),
  bindings: {
    onClose: '&',
    onProductPricingPlansRequested: '&',
    onSelection: '&',
    products: '<',
    serviceFeatures: '<',
    hasOverrideAccess: '<'
  },
  controller: ServiceFeaturesDialogController
};